import clsx from 'clsx';
import type { ReactNode } from 'react';

import { type DateInput, toDate } from '@repo/common';
import { DataTestIds } from '@repo/frontend-shared';
import { SDSPrimitiveButton } from '@repo/sds/SDSPrimitiveButton';
import { SDSText } from '@repo/sds/SDSText';

import './MonthlyCalendarDay.scss';

interface MonthlyCalendarDayProps {
  day: DateInput;
  monthDay: string;
  isSelected: boolean;
  isCurrentMonth: boolean;
  isToday: boolean;
  isInactive: boolean;
  onClick: () => void;
  marker?: ReactNode;
}

export function MonthlyCalendarDay({
  day,
  monthDay,
  isSelected,
  isCurrentMonth,
  isToday,
  isInactive,
  onClick,
  marker,
}: MonthlyCalendarDayProps) {
  const rootClassName = clsx('MonthlyCalendarDay', {
    'MonthlyCalendarDay--selected': isSelected,
    'MonthlyCalendarDay--different-month': !isCurrentMonth,
    'MonthlyCalendarDay--today': isToday,
    'MonthlyCalendarDay--inactive': isInactive,
  });
  const calendarDate = toDate(day);
  const yyyy = calendarDate.getFullYear();
  const mm = String(calendarDate.getMonth() + 1).padStart(2, '0');
  const dd = String(calendarDate.getDate()).padStart(2, '0');
  const calendarDayTestId = `${DataTestIds.COMMON.CALENDAR_DAY}-${yyyy}-${mm}-${dd}`;

  return (
    <SDSPrimitiveButton
      className={rootClassName}
      onClick={onClick}
      isDisabled={isInactive || !isCurrentMonth}
      dataTestId={calendarDayTestId}
    >
      <SDSText type="body-medium" text={monthDay} className="MonthlyCalendarDay__number" />
      {marker}
    </SDSPrimitiveButton>
  );
}
